import { getAuth, signInAnonymously as firebaseSignInAnonymously, signOut as firebaseSignOut } from "firebase/auth";
import { app } from "./firebase_service";

// Initialize Firebase Auth
const auth = getAuth(app);

/**
 * Sign in anonymously to Firebase Auth
 * This allows authenticated users to access Firebase Storage with proper permissions
 * @returns {Promise<UserCredential>} The user credential from Firebase Auth
 */
export const signInAnonymously = async () => {
  try {
    const userCredential = await firebaseSignInAnonymously(auth);
    return userCredential;
  } catch (error) {
    console.error("Error signing in anonymously:", error);
    throw error;
  }
};

/**
 * Sign out from Firebase Auth
 * Should be called when user logs out of the application
 * @returns {Promise<void>}
 */
export const signOut = async () => {
  try {
    await firebaseSignOut(auth);
  } catch (error) {
    console.error("Error signing out:", error);
    throw error;
  }
};

/**
 * Get the current Firebase Auth instance
 * @returns {Auth} The Firebase Auth instance
 */
export const getAuthInstance = () => auth;

// Export auth instance for direct access if needed
export { auth };
